import * as types from '../constants/ActionTypes';
import axios from "axios";

// Url's
const getFilterItems = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog`;


// All
export const filterAllSuccess = (allFilters) => ({
  type: types.FILTER_ALL_SUCCESS,
  allFilters
});
export const filterAllRequested = () => ({
  type: types.FILTER_ALL_REQUEST
});
export const filterAllFailure = error => ({
  type: types.FILTER_ALL_FAILURE,
  error
});

// Brand
export const filterBrandSuccess = (brands) => ({
  type: types.FILTER_BRAND_SUCCESS,
  brands
});
export const filterBrandRequested = () => ({
  type: types.FILTER_BRAND_REQUEST
});
export const filterBrandFailure = error => ({
  type: types.FILTER_BRAND_FAILURE,
  error
});

// Color
export const filterColorSuccess = (colors) => ({
  type: types.FILTER_COLOUR_SUCCESS,
  colors
});
export const filterColorRequested = () => ({
  type: types.FILTER_COLOUR_REQUEST
});
export const filterColorFailure = error => ({
  type: types.FILTER_COLOUR_FAILURE,
  error
});

// Range
export const filterRangeSuccess = (range) => ({
  type: types.FILTER_RANGE_SUCCESS,
  range
});
export const filterRangeRequested = () => ({
  type: types.FILTER_RANGE_REQUEST
});
export const filterRangeFailure = error => ({
  type: types.FILTER_RANGE_FAILURE,
  error
});

// Gender
export const filterGenderSuccess = (genders) => ({
  type: types.FILTER_GENDER_SUCCESS,
  genders
});
export const filterGenderRequested = () => ({
  type: types.FILTER_GENDER_REQUEST
});
export const filterGenderFailure = error => ({
  type: types.FILTER_GENDER_FAILURE,
  error
});

// Reset Filter
export const resetFilterSuccess = () => ({
  type: types.FILTER_RESET_SUCCESS
});

// Search filters selected
export const setFilters = (selected) => ({
  type: types.FILTER_SET,
  selected
});


// --- Helper Function for Error Messages ---
const getErrorMessage = (err) => {
  if (err.code === 'ECONNABORTED') {
    return 'Request timed out after 10 seconds';
  }
  return (err.response && err.response.data && err.response.data.message) || err.message || 'An unexpected error occurred';
};


// --- API Async Actions ---

export const getAllFilters = (options) => {
  return dispatch => {
    dispatch(filterAllRequested());

    axios.get(getFilterItems + '/category-filter', {
      params: {
        category_id: options.category_id,
        brand_code: options.brand_code,
        category_level_1: options.category_level_1 === null ? null : options.category_level_1 + '',
        category_level_2: options.category_level_2 === null ? null : options.category_level_2 + '',
        category_level_3: options.category_level_3 === null ? null : options.category_level_3 + '',
        category_level_4: options.category_level_4 === null ? null : options.category_level_4 + '',
        category_level_5: options.category_level_5 === null ? null : options.category_level_5 + '',
        connection_id: options.connection_id,
        gender_id: JSON.stringify(options.gender_id),
        tenant_name: options.tenant_name
      }
    })
      .then(res => {
        if (res.data && res.data.ack === "Success") {
          const categoryFilterData = res.data.results && res.data.results.category_filter_data;
          dispatch(filterAllSuccess(categoryFilterData));
        } else {
          const failureStatus = (res.data && res.data.status) || "Failed to fetch filters";
          dispatch(filterAllFailure(failureStatus));
        }
      })
      .catch(err => {
        dispatch(filterAllFailure(getErrorMessage(err)));
      });
  };
};

export const setSearchFilters = (selectedFilters) => {
  return dispatch => {
    dispatch(setFilters(selectedFilters));
  };
};

export const getBrandFilters = (connection_id) => {
  return dispatch => {
    dispatch(filterBrandRequested());

    axios.get(getFilterItems + '/get-brand-list', {
      params: { connection_id }
    })
      .then(res => {
        if (res.data && res.data.ack === "Success") {
          const brandData = res.data.results && res.data.results.brand;
          dispatch(filterBrandSuccess(brandData));
        } else {
          const failureStatus = (res.data && res.data.status) || "Failed to fetch brands";
          dispatch(filterBrandFailure(failureStatus));
        }
      })
      .catch(err => {
        dispatch(filterBrandFailure(getErrorMessage(err)));
      });
  };
};

export const getColourFilters = (connection_id) => {
  return dispatch => {
    dispatch(filterColorRequested());

    axios.get(getFilterItems + '/get-color-list', {
      params: {
        connection_id,
        brand_code: 'Mango'
      }
    })
      .then(res => {
        if (res.data && res.data.ack === "Success") {
          const colorData = res.data.results && res.data.results.color;
          dispatch(filterColorSuccess(colorData));
        } else {
          const failureStatus = (res.data && res.data.status) || "Failed to fetch colors";
          dispatch(filterColorFailure(failureStatus));
        }
      })
      .catch(err => {
        dispatch(filterColorFailure(getErrorMessage(err)));
      });
  };
};

export const getGenderFilters = (connection_id) => {
  return dispatch => {
    dispatch(filterGenderRequested());

    axios.get(getFilterItems + '/get-gender-list', {
      params: { connection_id }
    })
      .then(res => {
        if (res.data && res.data.ack === "Success") {
          const genderData = res.data.results && res.data.results.gender;
          dispatch(filterGenderSuccess(genderData));
        } else {
          const failureStatus = (res.data && res.data.status) || "Failed to fetch genders";
          dispatch(filterGenderFailure(failureStatus));
        }
      })
      .catch(err => {
        dispatch(filterGenderFailure(getErrorMessage(err)));
      });
  };
};

export const getRangeFilters = ({ connection_id, brand_code, category_id }) => {
  return dispatch => {
    dispatch(filterRangeRequested());

    axios.get(getFilterItems + '/get-price-range', {
      params: {
        connection_id,
        brand_code,
        category_id
      }
    })
      .then(res => {
        if (res.data && res.data.ack === "Success") {
          const rangeData = res.data.results && res.data.results.price_range;
          dispatch(filterRangeSuccess(rangeData));
        } else {
          const failureStatus = (res.data && res.data.status) || "Failed to fetch price range";
          dispatch(filterRangeFailure(failureStatus));
        }
      })
      .catch(err => {
        dispatch(filterRangeFailure(getErrorMessage(err)));
      });
  };
};

export const restFilters = () => {
  return dispatch => {
    dispatch(resetFilterSuccess());
  };
};